import { jsx } from 'react/jsx-runtime';
import { useEffect, useCallback } from 'react';
import { useTheme } from '../../utils/hooks/use-theme.js';
import { Link } from '../link/link.component.js';

const setZendeskWebWidgetSettings = (theme, offset) => {
    const webWidgetSettings = {
        color: {
            theme: theme.colors.content.primary,
        },
        offset,
    };
    if (window === null || window === void 0 ? void 0 : window.zESettings)
        window.zESettings.webWidget = webWidgetSettings;
    else
        window.zESettings = { webWidget: webWidgetSettings };
};
const createZendeskScriptNode = ({ onClose, }) => {
    const zendeskScript = document.createElement('script');
    zendeskScript.async = true;
    zendeskScript.id = 'ze-snippet';
    zendeskScript.onload = function neverShowWebWidgetLauncher() {
        var _a;
        const hideWebWidget = () => {
            var _a;
            (_a = window === null || window === void 0 ? void 0 : window.zE) === null || _a === void 0 ? void 0 : _a.call(window, 'webWidget', 'hide');
        };
        hideWebWidget();
        (_a = window === null || window === void 0 ? void 0 : window.zE) === null || _a === void 0 ? void 0 : _a.call(window, 'webWidget:on', 'close', () => {
            hideWebWidget();
            if (onClose)
                onClose();
        });
    };
    zendeskScript.src =
        'https://static.zdassets.com/ekr/snippet.js?key=8d8c058c-05a1-4ab0-b7bc-5aceee833e01';
    zendeskScript.type = 'text/javascript';
    return zendeskScript;
};
const ContactSupportLink = ({ children = 'Leave a message', className = '', onZendeskOpen, onZendeskClose, widgetOffset = {}, zendeskAlreadyPresent = false, }) => {
    const theme = useTheme();
    useEffect(() => {
        if (zendeskAlreadyPresent)
            return;
        setZendeskWebWidgetSettings(theme, widgetOffset);
        const zendeskScript = createZendeskScriptNode({ onClose: onZendeskClose });
        document.body.appendChild(zendeskScript);
        return function cleanup() {
            document.body.removeChild(zendeskScript);
        };
    }, [zendeskAlreadyPresent, theme, widgetOffset, onZendeskClose]);
    const launchWebWidgetDialog = useCallback(() => {
        var _a, _b;
        (_a = window === null || window === void 0 ? void 0 : window.zE) === null || _a === void 0 ? void 0 : _a.call(window, 'webWidget', 'show');
        (_b = window === null || window === void 0 ? void 0 : window.zE) === null || _b === void 0 ? void 0 : _b.call(window, 'webWidget', 'open');
        if (onZendeskOpen)
            onZendeskOpen();
    }, [onZendeskOpen]);
    return (jsx(Link, Object.assign({ href: "#", type: "standalone", className: className, onClick: e => {
            launchWebWidgetDialog();
            e.preventDefault();
        } }, { children: children }), void 0));
};

export { ContactSupportLink };
